/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 80 80" }, this.props),
            React.createElement("path", { d: "m38.446 74.7924c-.119 0-.239-.013-.358-.043-.671-.165-1.143-.766-1.143-1.457v-30.444h-30.445c-.691 0-1.292-.472-1.457-1.143-.164-.671.151-1.367.763-1.687l66.793-34.849c.582-.301 1.292-.194 1.755.27.464.463.573 1.173.27 1.754l-34.849 66.794c-.263.503-.781.805-1.329.805zm-25.828-34.944h25.827c.829 0 1.5.671 1.5 1.5v25.826l29.812-57.137z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;